enum DatePart {

    days = "days",
    hours = "hours",
    minutes = "minutes",
    seconds = "seconds",
}

export default DatePart;
